class TrendingSearches extends HTMLElement {
  constructor() {
    super();
    this.searchInput = this.querySelector('input[type="search"]');
    this.trendingContainer = this.querySelector(".trending-searches-container");
    this.predictiveSearch = this.querySelector("[data-predictive-search]");

    console.log("TrendingSearches constructor:", {
      searchInput: this.searchInput,
      trendingContainer: this.trendingContainer,
      predictiveSearch: this.predictiveSearch,
    });

    if (this.searchInput && this.trendingContainer) {
      this.init();
    } else {
      console.log("Missing required elements for trending searches");
    }
  }

  init() {
    // Show trending searches on focus
    this.searchInput.addEventListener(
      "focus",
      this.showTrendingSearches.bind(this)
    );

    // Hide trending searches when clicking outside
    document.addEventListener("click", this.handleClickOutside.bind(this));

    // Hide trending searches on input (when user starts typing)
    this.searchInput.addEventListener(
      "input",
      this.hideTrendingSearches.bind(this)
    );

    // Hide trending searches when predictive search is active
    if (this.predictiveSearch) {
      this.predictiveSearch.addEventListener(
        "focus",
        this.hideTrendingSearches.bind(this)
      );
    }
  }

  showTrendingSearches() {
    console.log("Show trending searches called");
    if (this.trendingContainer && this.searchInput.value === "") {
      console.log("Showing trending container");
      this.trendingContainer.style.display = "block";

      // Hide predictive search when showing trending searches
      if (this.predictiveSearch) {
        this.predictiveSearch.style.display = "none";
      }
    }
  }

  hideTrendingSearches() {
    console.log("Hide trending searches called");
    if (this.trendingContainer) {
      this.trendingContainer.style.display = "none";
    }

    // Show predictive search when hiding trending searches
    if (this.predictiveSearch) {
      console.log("Showing predictive search");
      this.predictiveSearch.style.display = "block";
    }
  }

  handleClickOutside(event) {
    if (!this.contains(event.target)) {
      this.hideTrendingSearches();
    }
  }
}

customElements.define("trending-searches", TrendingSearches);

// Debug: Test if custom element is working
console.log("Trending searches script loaded");
document.addEventListener("DOMContentLoaded", function () {
  console.log("DOM loaded - checking for trending-searches elements");
  const trendingElements = document.querySelectorAll("trending-searches");
  console.log("Found trending-searches elements:", trendingElements.length);

  // Test if we can find the container directly
  const container = document.querySelector(".trending-searches-container");
  console.log("Found trending container directly:", container);

  // Test if we can find the search input
  const searchInputs = document.querySelectorAll('input[type="search"]');
  console.log("Found search inputs:", searchInputs.length);
  searchInputs.forEach((input, index) => {
    console.log(`Search input ${index}:`, input.id, input.placeholder);
  });
});
